import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form8825 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Form 8825 Rental Income & Deductions | TaxZerone"
          description="Learn how to file IRS Form 8825 to report rental real estate income and expenses for partnerships or S corps. E-file easily with Form 1120-S at TaxZerone."
          keywords=""
          canonical="resources/business-tax/form-8825/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Form 8825</span>
          </span>{' '}
          Rental Real Estate Income & Deduction — Complete 2025 Guide
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-8825/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    IRS Form 8825 at a glance
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        {' '}
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must file Form 8825
                        </strong>{' '}
                        and when it is required for partnerships and S
                        corporations that own rental real estate, including the
                        applicable filing deadlines and IRS reporting
                        requirements.
                      </span>
                    </li>
                    <li>
                      <span>
                        {' '}
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Form 8825 line by line,
                        </strong>{' '}
                        including property information, rental income,
                        deductible expenses, depreciation, other deductions, and
                        the calculation of net rental real estate income or
                        loss.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the 2025 Form 8825 updates,
                        </strong>{' '}
                        including separate reporting of gross rents and other
                        rental income, new other information codes, and Schedule
                        A (Form 8825) requirements for entities filing Schedule
                        M-3.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Learn how to complete IRS Form 8825 for reporting rental
                      real estate income, expenses, and net income or loss for
                      partnerships and S corporations. This guide covers Form
                      8825 instructions, 2025 updates, line-by-line
                      explanations, and filing requirements to help you
                      accurately report rental real estate activities.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatisnew" sx={{ color: '#0202ff' }}>
                          What’s New in Form 8825
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatisnew" sx={{ color: '#0202ff' }}>
                          What is IRS Form 8825?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#purpose" sx={{ color: '#0202ff' }}>
                          Purpose of Form 8825
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Form 8825?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#deadline" sx={{ color: '#0202ff' }}>
                          Filing Deadlines for Form 8825
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#section" sx={{ color: '#0202ff' }}>
                          Sections of IRS Form 4562 Explained
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#detailed" sx={{ color: '#0202ff' }}>
                          Detailed Line-by-Line Instructions for Form 8825
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whyis" sx={{ color: '#0202ff' }}>
                          Why is Page 2 Included in Form 8825?
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Errors and Penalties
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key Compliance Tips
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatisnew"
                >
                  What's New in Form 8825 (2025)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For tax years beginning in 2025, use the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    December 2025 revision of Form 8825.
                  </span>
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Updated Form Version
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Use the December 2025 revision for tax years beginning in
                    2025.
                  </li>
                  <li>Earlier revisions apply to prior tax years.</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  New Other Information Codes
                </Typography>
                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    New codes are added to{' '}
                    <span style={{ fontWeight: 600 }}> Line 1, Column (c)</span>{' '}
                    to report information related to property acquisitions,
                    dispositions, and other transactions.
                  </li>
                  <li>
                    These codes apply to partnerships and S corporations
                    required to file{' '}
                    <span style={{ fontWeight: 600 }}>Schedule M-3</span>.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Separate Reporting of Rental Income
                </Typography>
                <Typography variant="body1">
                  Rental real estate income must now be reported separately:
                </Typography>
                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Line 2a:</span> Gross
                    rents{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Line 2b:</span> Other
                    rental real estate income
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  New Schedule A (Form 8825)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Partnerships and S corporations required to file{' '}
                  <span style={{ fontWeight: 600 }}>Schedule M-3</span> must
                  complete{' '}
                  <span style={{ fontWeight: 600 }}>
                    Schedule A (Form 8825)
                  </span>{' '}
                  to report other rental real estate deductions. The total from
                  Schedule A is reported on{' '}
                  <span style={{ fontWeight: 600 }}>Form 8825, Line</span>
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What is IRS Form 8825?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  IRS Form 8825,{' '}
                  <span style={{ fontWeight: 600 }}>
                    Rental Real Estate Income and Expenses of a Partnership or
                    an S Corporation
                  </span>
                  , is used by partnerships filing{' '}
                  <span style={{ fontWeight: 600 }}>Form 1065</span> and S
                  corporations filing{' '}
                  <span style={{ fontWeight: 600 }}>Form 1120-S</span> to report
                  income, expenses, and net income or loss from rental real
                  estate activities.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Form 8825 provides details of:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Rental real estate income:
                    </span>{' '}
                    Gross rents and other income related to rental real estate
                    activities.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Rental expenses: </span>{' '}
                    Allowable expenses such as interest, insurance, taxes,
                    repairs, utilities, advertising, and other rental costs.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Depreciation:</span>{' '}
                    Depreciation deductions for eligible rental property (with
                    <span style={{ fontWeight: 600 }}> Form 4562</span> required
                    in certain situations).
                  </li>

                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Net rental real estate income or loss:{' '}
                    </span>{' '}
                    The final amount after subtracting rental expenses from
                    rental income, which flows through to partners or
                    shareholders.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  The reported rental real estate income or loss is passed
                  through to partners or shareholders through{' '}
                  <span style={{ fontWeight: 600 }}>
                    Schedule K-1 (Form 1065 or Form 1120-S)
                  </span>{' '}
                  .
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="purpose"
                >
                  Purpose of Form 8825
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Form 8825 serves two main purposes:
                </Typography>
                <Box component="ol" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Tax Transparency</span>{' '}
                    <br />
                    It discloses detailed rental income and expenses for each
                    property owned by the entity. This ensures the IRS can
                    verify that reported deductions match actual expenses.{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>IRS Oversight</span>{' '}
                    <br />
                    By reporting rental activities in detail, Form 8825 enables
                    the IRS to monitor:
                  </li>
                  <ul style={{ listStyleType: 'disc' }}>
                    <li>Accuracy of income reporting </li>
                    <li>Deductibility of expenses </li>
                    <li>
                      Compliance with passive activity rules under IRC Section
                      469{' '}
                    </li>
                  </ul>
                </Box>

                <Typography variant="body1" sx={{ mb: 4 }}>
                  This helps prevent abuse, such as inflating expenses or
                  misclassifying personal costs as business deductions.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Form 8825?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Form 8825 is required for entities that report rental real
                  estate income and expenses:
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>Corporations and Partnerships Required to File </li>
                  <ul>
                    <li>
                      S Corporations reporting rental real estate on{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1120-s/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1120-S
                      </Link>{' '}
                    </li>
                    <li>
                      Partnerships reporting rental real estate on{' '}
                      <Link
                        href="https://www.irs.gov/forms-pubs/about-form-1065"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 1065
                      </Link>{' '}
                    </li>
                  </ul>
                  <li>Entities Not Required to File </li>
                  <ul>
                    <li>
                      C corporations (they report rental income differently on{' '}
                      <Link
                        href="https://www.irs.gov/forms-pubs/about-form-1120"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 1120
                      </Link>
                      )
                    </li>
                    <li>
                      Sole proprietorships (report rental income/expenses on
                      Schedule E)
                    </li>
                    <li>Entities with no rental real estate activity </li>
                  </ul>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="deadline"
                >
                  Filing Deadlines for Form 8825
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Form 8825 must be filed with your main tax return:
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Due Date
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporations </TableCell>
                          <TableCell>Form 1120-S </TableCell>
                          <TableCell>March 16, 2026</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Partnership </TableCell>
                          <TableCell>Form 1065</TableCell>
                          <TableCell>March 16, 2026</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert severity="info" icon={false} sx={{ mb: 4 }}>
                  <b>Tip:</b> File Form 7004 to request an automatic extension
                  if you need more time.
                </Alert>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="section"
                >
                  Sections of IRS Form 4562 Explained
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Form 4562 contains six parts. Each section deals with a
                  specific type of deduction or property.
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Part
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Section Title
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Purpose
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Part I </TableCell>
                          <TableCell>
                            Election to Expense Certain Property (Section 179)
                          </TableCell>
                          <TableCell>
                            Deduct full cost of qualifying property{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Part II </TableCell>
                          <TableCell>Special Depreciation Allowance </TableCell>
                          <TableCell>
                            Claim bonus depreciation for eligible assets
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Part III </TableCell>
                          <TableCell>MACRS Depreciation</TableCell>
                          <TableCell>
                            Calculate annual depreciation using IRS methods
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Part IV </TableCell>
                          <TableCell>Summary </TableCell>
                          <TableCell>
                            Combine total deductions from all sections
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Part V </TableCell>
                          <TableCell>Listed Property </TableCell>
                          <TableCell>
                            Report assets like vehicles or equipment used for
                            business and personal purposes
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Part VI </TableCell>
                          <TableCell>Amortization </TableCell>
                          <TableCell>
                            Record deductions for intangible assets
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    scrollMarginTop: 83,
                  }}
                  id="detailed"
                >
                  Detailed Line-by-Line Instructions for Form 8825
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 18, sm: 17, xs: 16 },
                    mb: 0.5,
                  }}
                >
                  Basic Information
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f8825-basic-info-img.webp" />
                  <source srcSet="/assets/images/f8825-basic-info-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f8825-basic-info-img.png"
                    loading="lazy"
                    alt="Form 8825 showing taxpayer name and EIN details in the basic information section"
                    width={760}
                    height={118}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Name
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the legal name of the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    partnership or S corporation
                  </span>{' '}
                  as shown on your Tax Return
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Employer Identification Number (EIN)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the <span style={{ fontWeight: 600 }}>EIN</span> of the
                  partnership or S corporation filing{' '}
                  <span style={{ fontWeight: 600 }}> Form 8825</span>. Ensure it
                  matches the EIN on the tax return.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 18, sm: 17, xs: 16 },
                    mb: 0.5,
                  }}
                >
                  Rental Real Estate Income and Expenses
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f8825-rental-real-img.webp" />
                  <source srcSet="/assets/images/f8825-rental-real-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f8825-rental-real-img.png"
                    loading="lazy"
                    alt=" Form 8825 Rental Real Estate Income and Expenses section details"
                    width={760}
                    height={227}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 1: Rental Real Estate Property Information
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Reports details of each rental real estate property owned by
                  the partnership or S corporation.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Complete a separate column for each rental property.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column (a): Physical Address of Property
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  Enter:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                  <li>Street address</li>
                  <li> City </li>

                  <li> State </li>

                  <li> ZIP code </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  For foreign properties, include:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                  <li>Postal code </li>
                  <li>Country </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column (b): Type of Property Code
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  Enter the applicable property type code:
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Code
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Property Type
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>1 </TableCell>
                          <TableCell>Single-family residence </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>2 </TableCell>
                          <TableCell>Multi-family residence </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>3 </TableCell>
                          <TableCell>Vacation or short-term rental </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>4 </TableCell>
                          <TableCell>Commercial </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>5 </TableCell>
                          <TableCell>Land </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>6 </TableCell>
                          <TableCell>Royalties </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>7 </TableCell>
                          <TableCell>Self-rental </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>8 </TableCell>
                          <TableCell>Other property </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If you select{' '}
                  <span style={{ fontWeight: 600 }}> Code 8 (Other)</span>,
                  include a brief description on Form 8825 or attach a separate
                  statement.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column (c): Other Information Code
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Only partnerships and S corporations required to file
                    Schedule M-3
                  </span>{' '}
                  must complete this column. Enter the applicable{' '}
                  <span style={{ fontWeight: 600 }}>
                    other information code (A–I)
                  </span>
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Code
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Description
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>A </TableCell>
                          <TableCell>Nontaxable contribution </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>B </TableCell>
                          <TableCell>Other exchange </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>C </TableCell>
                          <TableCell>Taxable acquisition </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>D </TableCell>
                          <TableCell>
                            New construction, renovation, or basis
                            adjustment{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>E </TableCell>
                          <TableCell>Reserved for future use </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>F </TableCell>
                          <TableCell>Nontaxable distribution </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>G </TableCell>
                          <TableCell>Taxable disposition </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>H </TableCell>
                          <TableCell>Abandonment </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>I </TableCell>
                          <TableCell>Other supplement </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Include additional details when required.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column (d): Fair Rental Days
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the total number of days the property was rented at{' '}
                  <span style={{ fontWeight: 600 }}>fair rental value</span>{' '}
                  during the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column (e): Personal-Use Days
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the number of days the property was used personally.
                  Follow the IRS personal-use rules under{' '}
                  <span style={{ fontWeight: 600 }}>Section 280A</span> when
                  determining these days.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 18, sm: 17, xs: 16 },
                    mb: 0.5,
                  }}
                >
                  Rental Real Estate Income
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f8825-rental-income-img.webp" />
                  <source srcSet="/assets/images/f8825-rental-income-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f8825-rental-income-img.png"
                    loading="lazy"
                    alt="Form 8825 showing rental property income information "
                    width={760}
                    height={99}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 2a: Gross Rents
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the total{' '}
                  <span style={{ fontWeight: 600 }}>gross rental income</span>{' '}
                  received from each rental real estate property during the tax
                  year. Report the Total amount before deducting any rental
                  expenses.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 2b: Other Income Related to Rental Real Estate Activity
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter any{' '}
                  <span style={{ fontWeight: 600 }}>other income</span> related
                  to the rental real estate activity that isn't included on{' '}
                  <span style={{ fontWeight: 600 }}>Line 2a</span>. This may
                  include rental-related fees or other taxable income generated
                  by the property.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Lease cancellation payments, parking fees or laundry income
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 2c: Total Rental Real Estate Income
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add{' '}
                  <span style={{ fontWeight: 600 }}>Line 2a (Gross Rents)</span>{' '}
                  and{' '}
                  <span style={{ fontWeight: 600 }}>
                    Line 2b (Other Income)
                  </span>{' '}
                  for each property. Enter the total rental real estate income
                  before subtracting any expenses.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 18, sm: 17, xs: 16 },
                    mb: 0.5,
                  }}
                >
                  Rental Real Estate Expenses
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f8825-rental-estate-img.webp" />
                  <source srcSet="/assets/images/f8825-rental-estate-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f8825-rental-estate-img.png"
                    loading="lazy"
                    alt="Form 8825 showing rental real estate expenses section"
                    width={760}
                    height={326}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 3: Advertising
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the advertising expenses paid to promote the rental real
                  estate property and attract tenants.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Online rental listings, newspaper advertisements, rental
                    signs, or promotional materials for the property.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 4: Auto and Travel
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the allowable auto and travel expenses incurred for
                  managing or maintaining rental real estate activities.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Travel expenses for visiting rental properties, collecting
                    rent, or supervising property maintenance
                  </i>
                </Alert>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 5: Cleaning and Maintenance
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter expenses paid for cleaning and routine maintenance of
                  rental real estate properties.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Cleaning services, lawn care, pest control, or routine
                    property upkeep.
                  </i>
                </Alert>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 6: Commissions
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter commissions paid for rental real estate activities.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Payments to rental agents or property managers for finding
                    tenants or managing rental arrangements.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 7: Insurance
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  Enter insurance expenses related to rental property,
                  including:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Property insurance</li>
                  <li>Liability insurance </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 8: Interest
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter deductible interest expenses related to rental real
                  estate activities.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note:</b>
                  <i>
                    {' '}
                    Interest expense may be limited under{' '}
                    <span style={{ fontWeight: 600 }}>Section 163(j)</span>.
                    Review{' '}
                    <span style={{ fontWeight: 600 }}>
                      Form 8990, Limitation on Business Interest Expense Under
                      Section 163(j)
                    </span>
                    , if applicable.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 9: Legal and Other Professional Fees
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  Enter professional fees related to rental property activities,
                  including:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Legal services</li>
                  <li>Accounting fees </li>
                  <li>Tax preparation fees </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 10: Real Estate Taxes
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the real estate taxes paid or accrued for rental real
                  estate properties.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Property taxes assessed by state, local, or foreign
                    governments on rental properties.
                  </i>
                </Alert>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 11: Repairs
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter expenses paid for repairs that keep the rental property
                  in normal operating condition.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 2, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Fixing leaks, repairing broken fixtures, or replacing
                    damaged parts.
                  </i>
                </Alert>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note:</b>
                  <i>
                    {' '}
                    Do not include improvements that increase the value of the
                    property; those costs must generally be capitalised.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 12: Utilities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter utility expenses paid for rental real estate properties.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 2, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Electricity, water, gas, trash collection, or other utility
                    services provided for the property.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 13: Wages and Salaries
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter wages and salaries paid to employees for services
                  related to rental real estate activities.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Payments to property maintenance staff, caretakers, or other
                    employees managing rental properties.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 14: Depreciation
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the depreciation deduction allowed for rental real
                  estate property.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 2, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note:</b>
                  <i>
                    {' '}
                    Land is not depreciable. Attach{' '}
                    <span style={{ fontWeight: 600 }}>
                      Form 4562, Depreciation and Amortization,
                    </span>{' '}
                    if property was placed in service during the current tax
                    year or depreciation is claimed for vehicles or listed
                    property
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 15: Reserved for Future Use
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No entry is required. This line is reserved for future IRS
                  use.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 16: Reserved for Future Use
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No entry is required. This line is reserved for future IRS
                  use.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 17: Other Deductions
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter other deductible rental real estate expenses that are
                  not reported on Lines 3 through 16.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 2, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note:</b>
                  <i>
                    {' '}
                    Partnerships and S corporations required to file{' '}
                    <span style={{ fontWeight: 600 }}>Schedule M-3</span> must
                    complete{' '}
                    <span style={{ fontWeight: 600 }}>
                      Schedule A (Form 8825)
                    </span>{' '}
                    for other deductions and report the total amount on this
                    line.
                  </i>
                </Alert>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 2, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Other allowable rental expenses not included in the listed
                    expense categories.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 18: Total Rental Real Estate Expenses
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add Lines{' '}
                  <span style={{ fontWeight: 600 }}>3 through 17</span> to
                  calculate the total rental real estate expenses for each
                  property.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 19: Income or (Loss) From Each Rental Real Estate
                  Property
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Subtract{' '}
                  <span style={{ fontWeight: 600 }}>
                    Line 18 (Total Expenses)
                  </span>{' '}
                  from{' '}
                  <span style={{ fontWeight: 600 }}>
                    Line 2c (Total Rental Real Estate Income)
                  </span>{' '}
                  to determine the net income or loss for each rental property.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Calculation:
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Line 2c − Line 18 = Line 19
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 18, sm: 17, xs: 16 },
                    mb: 0.5,
                  }}
                >
                  Final Summary Lines
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f8825-final-lines-img.webp" />
                  <source srcSet="/assets/images/f8825-final-lines-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f8825-final-lines-img.png"
                    loading="lazy"
                    alt=" Form 8825 showing final summary lines for rental real estate"
                    width={760}
                    height={224}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 20a: Total Rental Real Estate Income
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add the{' '}
                  <span style={{ fontWeight: 600 }}>
                    total rental real estate income
                  </span>{' '}
                  from <span style={{ fontWeight: 600 }}>Line 2c</span> for all
                  rental properties reported on Form 8825, including any
                  attached page 2.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 20b: Total Rental Real Estate Expenses
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add the{' '}
                  <span style={{ fontWeight: 600 }}>
                    total rental real estate expenses
                  </span>{' '}
                  from <span style={{ fontWeight: 600 }}>Line 18</span> for all
                  rental properties, including any attached page 2.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 21: Net Gain (Loss) From Form 4797
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the{' '}
                  <span style={{ fontWeight: 600 }}>net gain or loss</span> from
                  the disposition of rental real estate property reported on{' '}
                  <span style={{ fontWeight: 600 }}>
                    Form 4797, Part II, Line 17
                  </span>
                  .{' '}
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 2, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Example:</b>
                  <i>
                    {' '}
                    Gain or loss from selling a rental building or other
                    depreciable rental real estate property.
                  </i>
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 22a: Net Income (Loss) From Partnerships, Estates, and
                  Trusts
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter your share of{' '}
                  <span style={{ fontWeight: 600 }}>
                    net rental real estate income or loss
                  </span>
                  received from partnerships, estates, or trusts as reported on
                  <span style={{ fontWeight: 600 }}> Schedule K-1</span>.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 22b: Identify Related Entities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the <span style={{ fontWeight: 600 }}>name</span> and{' '}
                  <span style={{ fontWeight: 600 }}>
                    Employer Identification Number (EIN)
                  </span>{' '}
                  of each partnership, estate, or trust reported on{' '}
                  <span style={{ fontWeight: 600 }}>Line 22a</span>. Attach
                  additional statements if needed.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 23: Net Rental Real Estate Income (Loss)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Combine the amounts from{' '}
                  <span style={{ fontWeight: 600 }}>Lines 20a through 22a</span>{' '}
                  to calculate the{' '}
                  <span style={{ fontWeight: 600 }}>
                    net rental real estate income or loss.
                  </span>{' '}
                  Enter the result on{' '}
                  <span style={{ fontWeight: 600 }}>Schedule K, Line 2</span> of
                  <span style={{ fontWeight: 600 }}> Form 1065</span> or{' '}
                  <span style={{ fontWeight: 600 }}> Form 1120-S</span>
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whyis"
                >
                  Why Is Page 2 Included in Form 8825?
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Page 2 is used to report{' '}
                    <span style={{ fontWeight: 600 }}>
                      additional rental real estate properties
                    </span>{' '}
                    when you have{' '}
                    <span style={{ fontWeight: 600 }}>
                      more than four properties
                    </span>
                    .
                  </li>
                  <li>
                    Complete{' '}
                    <span style={{ fontWeight: 600 }}>Lines 1 through 19</span>{' '}
                    for each additional property, then combine the totals and
                    report{' '}
                    <span style={{ fontWeight: 600 }}>
                      Lines 20a through 23
                    </span>{' '}
                    only once on{' '}
                    <span style={{ fontWeight: 600 }}> Page 1</span>.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Errors and Penalties
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Frequent Mistakes:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>Not filing Form 8825 when rental activity exists </li>
                  <li>Misreporting rental income or expenses </li>
                  <li>Failing to report depreciation properly </li>
                  <li>
                    Mismatch between Form 8825 and Form 1065/1120-S totals{' '}
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Consequences:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Disallowed deductions </li>
                  <li>Additional taxes, penalties, or interest charges </li>
                </Box>
                <Alert severity="info" icon={false} sx={{ mb: 4 }}>
                  <b>Pro Tip:</b> Always reconcile your rental income and
                  expenses with supporting documentation.
                </Alert>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key Compliance Tips
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    Maintain detailed property records, receipts, and
                    invoices{' '}
                  </li>
                  <li>Attach supporting schedules for multiple properties </li>
                  <li>Ensure totals match your main return </li>
                  <li>
                    {' '}
                    <Link
                      href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      File Form 7004
                    </Link>{' '}
                    for extensions if needed{' '}
                  </li>
                  <li>Review IRS instructions each year before filing </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Do all partnerships and S corporations file Form 8825?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Only those with rental real estate activities are required to
                  file.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Can Form 8825 be e-filed separately?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. It must be filed with Form 1120-S or 1065. TaxZerone
                  includes it automatically if required.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. How should multiple properties be reported?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Attach separate schedules for each property listing income and
                  expenses individually.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Are rental losses deductible?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, but only within limits of passive activity loss rules
                  under IRC Section 469.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. Is depreciation required?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes. Depreciation must be calculated and reported using Form
                  4562.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  6. Does personal use affect reporting?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes. Expenses must be allocated between rental and personal
                  use; only rental expenses are deductible.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Simplify your partnership or S corporation rental real estate
              reporting with TaxZerone,{' '}
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              ensuring full IRS compliance, accurate deductions, and hassle-free
              e-filing.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=8825`}
              >
                Start E-Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form8825;
